import React, { useEffect, useState } from 'react';
import { ShoppingCart, CheckCircle } from 'lucide-react';
const NAMES = ['Laura M. de Argentina', 'Carlos R. de México', 'Ana P. de España', 'Martín G. de Chile', 'Lucía T. de Colombia', 'Sofía L. de Perú', 'Diego F. de Uruguay', 'Valentina C. de Ecuador', 'Andrés B. de Paraguay', 'Camila H. de Bolivia', 'Santiago D. de Venezuela', 'Isabella N. de Costa Rica', 'Mateo V. de Panamá', 'Daniela S. de Guatemala', 'Sebastián J. de Honduras', 'Paula K. de El Salvador', 'Nicolás W. de Nicaragua', 'Mariana Z. de Cuba', 'Tomás A. de Rep. Dominicana', 'Florencia E. de Puerto Rico', 'Joaquín O. de Brasil', 'Renata I. de México', 'Emilio U. de Argentina', 'Catalina Y. de Chile', 'Gabriel Q. de Colombia', 'Victoria X. de España', 'Federico P. de Perú', 'Antonella R. de Uruguay', 'Maximiliano L. de Ecuador', 'Julieta M. de Paraguay'];
type NotificationType = 'sale' | 'cart';
type Position = 'left' | 'right';
interface NotificationData {
  name: string;
  type: NotificationType;
  position: Position;
  id: number;
}
export function SaleNotifications() {
  const [notification, setNotification] = useState<NotificationData | null>(null);
  const [availableNames, setAvailableNames] = useState<string[]>([...NAMES]);
  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    let cycleCount = 0;
    let notificationCountInCycle = 0;
    let isWaiting = false;
    const showNotification = () => {
      if (isWaiting) return;
      // Get random name without repetition in current cycle
      let currentNames = availableNames;
      if (currentNames.length === 0) {
        currentNames = [...NAMES]; // Reset pool if empty
      }
      const nameIndex = Math.floor(Math.random() * currentNames.length);
      const name = currentNames[nameIndex];
      // Update available names for next time
      const newAvailableNames = [...currentNames];
      newAvailableNames.splice(nameIndex, 1);
      setAvailableNames(newAvailableNames);
      const type: NotificationType = Math.random() > 0.5 ? 'sale' : 'cart';
      const position: Position = Math.random() > 0.5 ? 'left' : 'right';
      setNotification({
        name,
        type,
        position,
        id: Date.now()
      });
      // Hide after 4 seconds
      setTimeout(() => {
        setNotification(null);
      }, 4000);
      notificationCountInCycle++;
      if (notificationCountInCycle < 4) {
        // Schedule next notification in 5 seconds
        timeoutId = setTimeout(showNotification, 5000);
      } else {
        // End of cycle, wait 60 seconds
        isWaiting = true;
        notificationCountInCycle = 0;
        timeoutId = setTimeout(() => {
          isWaiting = false;
          showNotification();
        }, 60000);
      }
    };
    // Start the sequence
    timeoutId = setTimeout(showNotification, 9000);
    return () => clearTimeout(timeoutId);
  }, []); // Empty dependency array to run once on mount
  if (!notification) return null;
  const isLeft = notification.position === 'left';
  return <div className={`fixed top-[70px] z-[1000] transition-all duration-500 ease-in-out transform ${isLeft ? 'left-[16px]' : 'right-[16px]'} ${notification ? 'translate-x-0 opacity-100' : isLeft ? '-translate-x-full opacity-0' : 'translate-x-full opacity-0'}`} data-id="element-238">
      <div className="bg-white rounded-2xl shadow-xl p-3 flex items-center gap-3 max-w-[300px] border border-gray-100" data-id="element-239">
        <div className={`w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 ${notification.type === 'sale' ? 'bg-green-100 text-green-600' : 'bg-blue-100 text-blue-600'}`} data-id="element-240">
          {notification.type === 'sale' ? <CheckCircle size={20} data-id="element-241" /> : <ShoppingCart size={20} data-id="element-242" />}
        </div>
        <div data-id="element-243">
          <p className="text-[13px] font-bold text-[#111827] leading-tight" data-id="element-244">
            {notification.name}
          </p>
          <p className="text-[11px] text-gray-600 leading-tight mt-0.5" data-id="element-245">
            {notification.type === 'sale' ? 'acaba de comprar La Biblia del Café' : 'agregó La Biblia del Café al carrito'}
          </p>
          <p className="text-[10px] text-gray-400 mt-1" data-id="element-246">Ahora</p>
        </div>
      </div>
    </div>;
}